// Browser entry — bundled by esbuild into public/app.js (+ app.css). Imports the
// C1 design CSS so the bundle is self-contained, then boots the app on the #app root.
import "./design/tokens.css";
import "./design/type.css";
import "./design/base.css";
import "./design/components.css";
import "./app/app.css";
import { bootstrap } from "./app/app.js";

function start(): void {
  const root = document.getElementById("app");
  if (!root) throw new Error("webapp: #app root element missing");
  void bootstrap(root);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
